import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Fab } from '@material-ui/core';
import ChatIcon from '@material-ui/icons/Chat';
import './AIAssistant.css'
import ChatWindow from '../ChatWindow/ChatWindow';

class AIAssistant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatOpened: false,
    };
  }

  render() {
    const changeChatWindow = (event) => {
      this.setState({chatOpened: !this.state.chatOpened});
    }
    const { isFetching, messages, state, getAIAssistants } = this.props

    return (
      <>
        <div>
          {this.state.chatOpened && <ChatWindow isFetching={isFetching} messages={messages} state={state} getAIAssistants={getAIAssistants} onClose={changeChatWindow}/>}
        </div>
        {!this.state.chatOpened && <Fab color="primary" aria-label="add" className='bottom-right-corner' onClick={changeChatWindow}>
            <ChatIcon />
        </Fab>}
      </>
    );
  }
}

AIAssistant.propTypes = {
  getAIAssistants: PropTypes.func.isRequired,
};

export default AIAssistant;